var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectorRef, Component, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../../component/base/contentbase.component';
import { ContentBaseService } from '../../component/base/contentbase.service';
import { MenuService } from '../../component/menu/menu.service';
import { ColumnService } from '../../items/columns/column/column.service';
import { ConfigService } from '../../service/config.service';
var AuComponent = /** @class */ (function (_super) {
    __extends(AuComponent, _super);
    function AuComponent(router, route, logger, action, message, page, service, menuService, colService, cdRef, config) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.menuService = menuService;
        _this.colService = colService;
        _this.cdRef = cdRef;
        _this.config = config;
        _this.componentName = AuComponent.name;
        _this.components = [];
        _this.url = '';
        _this.open = false;
        _this.menuScrollTop = 0;
        _this.edit_messages = false;
        _this.initEvents = [];
        _this.checkMenu = false;
        _this.awsEnvironment = _this.config.config['aws_environment'];
        logger.debug('route:', route);
        return _this;
    }
    AuComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        if (window.innerWidth <= 575) {
            this.menuService.setMenuOpenState('menu-showLeftPush', false);
        }
        var open = this.menuService.getMenuOpenState('menu-showLeftPush');
        this.open = (typeof open === 'undefined') ? true : open;
        this.menuScrollTop = this.menuService.getMenuScrollTop();
        this.routeSubscription = this.route.data.subscribe(function (data) {
            _this.components = data.meta.components;
            _this.url = _this.router.url;
            _this.menuService.changeMenuCurrent(data.meta.menus, _this.route.snapshot.queryParamMap.get('menu'), _this.url);
            _this.checkMenu = true;
            var _params = {};
            _this.route.params.subscribe(function (params) {
                _params = Object.assign({}, params);
                _this.params = _params;
            });
            _this.action.setInit(_params, data.meta, _this.msgSnapshot);
        });
    };
    AuComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        if (meta.events) {
            this.action.setEvents(meta.events);
            this.edit_messages = false;
            if (typeof meta.events['edit_messages'] !== 'undefined') {
                this.edit_messages = true;
            }
        }
        if (meta.messages) {
            this.org_msg = meta.messages;
            this.action.setMsg(this.msgSnapshot);
        }
    };
    AuComponent.prototype.setUnsubscribe = function () {
        this.changeSubscription.unsubscribe();
    };
    AuComponent.prototype.onAfterView = function (e, index) {
        if (this.components.length === (index + 1)) {
            this.initEvents = [];
            this.initEvent(this.components);
        }
    };
    AuComponent.prototype.onEventSubscribe = function (e) {
        if (e === 'languageChange') {
            this.checkMenu = true;
            this.initEvents = [];
            this.initEvent(this.components);
        }
        else if (e === 'EditMessages') {
            this.message.setMetaMessages(this.org_msg);
            this.action.firstAction('edit_messages');
        }
    };
    AuComponent.prototype.onModeSubscribe = function () {
        window.scrollTo(0, 0);
    };
    AuComponent.prototype.onRefSubscribe = function () {
        window.scrollTo(0, 0);
    };
    AuComponent.prototype.initEvent = function (components) {
        for (var _i = 0, components_1 = components; _i < components_1.length; _i++) {
            var comp = components_1[_i];
            if (comp.event) {
                if (this.initEvents.indexOf(comp.event) >= 0) {
                    this.logger.error('"' + comp.event + '" event is duplicated.');
                }
                else {
                    this.initEvents.push(comp.event);
                    this.action.firstAction(comp.event, { log: false });
                }
            }
            if (comp.components) {
                this.initEvent(comp.components);
            }
        }
    };
    AuComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    AuComponent.prototype.ngAfterViewInit = function () {
        var self = this;
        $('#showLeftPush').click(function () {
            $(this).toggleClass('active');
            $('#menuPush').toggleClass('pushMenuWrapper-toleft');
            $('#menu-s1').toggleClass('menu-close');
            self.menuService.setMenuOpenState('menu-showLeftPush', $(this).hasClass('active'));
            self.colService.refresh(300);
        });
    };
    AuComponent.prototype.onResize = function () {
        var _this = this;
        window.clearTimeout(this.timeoutID);
        this.timeoutID = window.setTimeout(function () {
            if (window.innerWidth <= 575) {
                $('#showLeftPush').removeClass('active');
                $('#menuPush').addClass('pushMenuWrapper-toleft');
                $('#menu-s1').addClass('menu-close');
                _this.menuService.setMenuOpenState('menu-showLeftPush', false);
            }
            else {
                // 画面幅小→画面幅大による左メニューの自動表示は行わない
                // $('#showLeftPush').addClass('active');
                // $('#menuPush').removeClass('pushMenuWrapper-toleft');
                // $('#menu-s1').removeClass('menu-close');
                // this.menuService.setMenuOpenState('menu-showLeftPush', true);
            }
        }, 300);
    };
    AuComponent.prototype.menuScrollEvent = function (e) {
        this.menuScrollTop = e.target.scrollTop;
        this.checkMenu = false;
    };
    AuComponent.prototype.menuClickEvent = function (e) {
        this.checkMenu = false;
    };
    AuComponent.prototype.onScroll = function () {
        if ($(window).scrollTop() > 100) {
            $('.pageTopBtn').fadeIn();
        }
        else {
            $('.pageTopBtn').fadeOut();
        }
        this.checkMenu = false;
    };
    AuComponent.prototype.pageTop = function () {
        $('html, body').animate({ scrollTop: 0 }, 500);
    };
    AuComponent.prototype.ngAfterViewChecked = function () {
        this.cdRef.detectChanges();
        if (document.getElementById('menu-s1').scrollTop !== this.menuScrollTop) {
            document.getElementById('menu-s1').scrollTop = this.menuScrollTop;
        }
        var currentTop = ($('.gNav_accAnchor-current').position() ? $('.gNav_accAnchor-current').position().top : null);
        if (this.checkMenu && currentTop) {
            var currentHeight = $('.gNav_accAnchor-current').outerHeight();
            var menuTop = $('#menu-s1').scrollTop();
            var menuHeight = $('#menu-s1').outerHeight();
            if (currentTop < 0) {
                document.getElementById('menu-s1').scrollTop = menuTop + currentTop;
                this.menuScrollTop = menuTop + currentTop;
            }
            else if (menuHeight < (currentTop + currentHeight)) {
                document.getElementById('menu-s1').scrollTop = menuTop + currentTop;
                this.menuScrollTop = menuTop + currentTop;
            }
        }
    };
    AuComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.menuService.setMenuScrollTop(this.menuScrollTop);
        this.routeSubscription.unsubscribe();
    };
    AuComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    template: "<pa-header [unit]=\"false\"></pa-header>\n<div [ngClass]=\"open ? 'pushMenuWrapper' : 'pushMenuWrapper pushMenuWrapper-toleft'\" id=\"menuPush\">\n  <nav pa-menu [ngClass]=\"open ? 'gNav' : 'gNav menu-close'\" id=\"menu-s1\" (scroll)=\"menuScrollEvent($event)\" (click)=\"menuClickEvent($event)\"></nav>\n  <main class=\"main\">\n    <p *ngIf=\"awsEnvironment==='staging'\" class=\"-m-1 -comment\" [innerHTML]=\"(msg | async)['au.COMPONENTS.label.environment_attention_content']\"></p>\n    <alertblock></alertblock>\n    <div class=\"container-fluid\">\n      <content *ngFor=\"let component of components; let index = index;\" [component]=\"component\" (afterView)=\"onAfterView($event, index)\"></content>\n    </div>\n  </main>\n  <div class=\"container-fluid\">\n    <div class=\"row -m-3\">\n      <div class=\"col-sm-12 -txtalnright\">\n        <btn *ngIf=\"edit_messages && url !== '/edit-messages/entry'\"\n             [componentName]=\"'EditMsgBtnComp'\"\n             [component]=\"{\n                params: {\n                  buttons: [{\n                    type: 'button',\n                    event: 'EditMessages',\n                    caption: (msg | async)['AuComponent.button.editmessages']\n                  }]\n                }\n             }\"></btn>\n      </div>\n    </div>\n  </div>\n  <button class=\"pageTopBtn\" type=\"button\" style=\"display: none;\" (click)=\"pageTop()\"></button>\n  <pa-footer></pa-footer>\n</div>\n<loading></loading>\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    AuComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ContentBaseService },
        { type: MenuService },
        { type: ColumnService },
        { type: ChangeDetectorRef },
        { type: ConfigService }
    ]; };
    AuComponent.propDecorators = {
        onResize: [{ type: HostListener, args: ['window:resize',] }],
        onScroll: [{ type: HostListener, args: ['window:scroll',] }]
    };
    return AuComponent;
}(ContentBaseComponent));
export { AuComponent };
//# sourceMappingURL=au.component.js.map